import * as React from 'react';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {CalendarSync} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import {authToService} from '../../setup/integrations/auth-to-service';
import {getAuthUrl} from '../../setup/integrations/integration-mutation-response-helpers';

type Props = {
    status: CalendarSync;
    windowFeatures: any;
    onAuthError?: (errMsg: string) => void;
    onAuthStart?: () => void;
    refetchSyncStatus: () => Promise<any>;
    onSuccess?: () => any;
    setOffice365CalendarSyncIsEnabled: (arg1: boolean) => Promise<any>;
    setGoogleCalendarSyncIsEnabled: (arg1: boolean) => Promise<any>;
};

export function EnableCalendar(props: Props) {
    const {
        status,
        windowFeatures,
        onAuthError,
        onAuthStart,
        refetchSyncStatus,
        setGoogleCalendarSyncIsEnabled,
        setOffice365CalendarSyncIsEnabled,
    } = props;

    const trackCalendarEnabled = () => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_CONNECTED_CALENDAR_VIA_SCHEDULER);
    };

    const primaryCalendar = status.calendars.find((c) => c.syncType === 'PRIMARY');

    return (
        <StackLegacy spacing={16} alignCenter={true}>
            Your meetings cannot be booked until you enable your calendar.
            <Button
                variant='primary'
                size='big'
                onClick={() => {
                    if (!primaryCalendar) {
                        appHistory.push('/my-account/calendar');
                    } else if (status.externalService === 'OFFICE365') {
                        setOffice365CalendarSyncIsEnabled(true)
                            .then(trackCalendarEnabled)
                            .then(() => {
                                if (props.onSuccess) {
                                    props.onSuccess();
                                }
                            });
                    } else {
                        setGoogleCalendarSyncIsEnabled(true)
                            .then(getAuthUrl)
                            .then((authUrl) => {
                                trackCalendarEnabled();

                                if (authUrl) {
                                    onAuthStart?.();
                                    authToService({
                                        authUrl,
                                        windowFeatures,
                                        authCheckUrl: '/google/has-auth',
                                    })
                                        .then(({hasAuth}) => {
                                            if (hasAuth) {
                                                refetchSyncStatus();
                                            }
                                        })
                                        .catch((errMsg) => {
                                            onAuthError?.(errMsg);
                                        });
                                }
                            })
                            .then(() => {
                                if (props.onSuccess) {
                                    props.onSuccess();
                                }
                            });
                    }
                }}
            >
                Enable
            </Button>
        </StackLegacy>
    );
}
